import PropTypes from "prop-types"
import { AppBar } from "@mui/material"
import LogoHomeLink from "components/logo/home-link"
import ServerNotifications from "modules/server-notifications"
import HelpMenu from "modules/help-menu"
import ThemeModeToggle from "components/theme-mode-toggle"
import { KellyLauncherButton } from "connected-components/agent-chat/components/kelly-launcher-button"

/**
 * @param {object} props
 * @param {string} props.account
 * @param {React.ElementType} [props.Icon]
 * @param {string} [props.title]
 * @param {React.ReactNode} [props.children]
 * @param {string} [props.className]
 * @param {string | null} [props.modelId]
 */
export default function HomeHeader({ account, Icon = null, title = "", children, className, modelId }) {
  return <AppBar position="sticky" className={className}>
    <div className="header-app-bar">
      <div className="left">
        <LogoHomeLink account={account} />
        {Icon && <Icon />}
        {title && <span className="title">{title}</span>}
        {children}
      </div>
      <div className="right">
        <ServerNotifications />
        <HelpMenu modelId={modelId} />
        <ThemeModeToggle inline />
        <KellyLauncherButton />
      </div>
    </div>
  </AppBar>
}

HomeHeader.propTypes = {
  account: PropTypes.string.isRequired,
  Icon: PropTypes.object,
  title: PropTypes.string,
  className: PropTypes.string,
  modelId: PropTypes.string,
}
